﻿import buttonLoader from '../../utilities/buttonLoader.js';

var mypageChangePassword = {};

mypageChangePassword = {

  init: function () {
    var me = this;
    var form = document.getElementsByClassName('form__changePassword')[0];

    if (form) {

      me.bind(form);
    }

  },

  bind: function (form) {
    var me = this;

    form.addEventListener('submit', function (e) {

      e.preventDefault();

      var m = form.querySelector('.alert');

      if (m) {
        m.remove();
      }

      me.submit(form);

    });
  },

  submit: function (form) {
    var me = this;
    var button = form.querySelector('button[type=submit]');

    buttonLoader.start(button);

    var data = new FormData(form);

    var xhr = new XMLHttpRequest();
    xhr.open(form.getAttribute("method"), form.getAttribute("action"));

    xhr.onload = function () {

      var resp = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {

        if (resp.success) {

          window.location = "/minar-sidur";

        } else {

          buttonLoader.reset(button);

          me.renderMessage(button, resp.message, 'error');
        }

      } else {

        buttonLoader.reset(button);

        me.renderMessage(button, 'Villa kom upp. Ef þessi skilaboð halda áfram að birtast hafið þá samband.', 'error');
      }

    };

    xhr.send(data);
    
  },

  renderMessage: function (el, message, type) {
    el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');

  }

};

mypageChangePassword.initialize = function () {
  mypageChangePassword.init();
};

module.exports = mypageChangePassword;
